module.exports = require("live/widgets/decorators/react");